var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "group-title"
  }, [_c('div', {
    staticClass: "group-title__left"
  }, [_vm.iconLeft ? _c('div', {
    staticClass: "group-title__icon",
    style: {
      backgroundImage: ("url(" + (_vm.iconLeft) + ")")
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "group-title__text"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _vm.timerDate || _vm.promocode || _vm.imgDesktop || _vm.imgMobile || _vm.iconRight ? _c('div', {
    staticClass: "group-title__right"
  }, [_vm.timerDate ? _c('div', {
    staticClass: "group-title__timer"
  }, [_c('GGTimerBlock', {
    attrs: {
      "size": _vm.timerSize,
      "time": _vm.timerDate,
      "color": _vm.timerColor
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.promocode ? _c('div', {
    staticClass: "group-title__promocode"
  }, [_c('GGPromoButton', {
    attrs: {
      "text": _vm.promocode,
      "color": _vm.promocodeColor,
      "copied-text": "Скопировано"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c(_vm.imgLink ? 'GGLink' : 'div', {
    tag: "component",
    class: _vm.imgLink ? 'group-title__link' : 'group-title__img-wrapper',
    attrs: {
      "to": _vm.imgLink
    }
  }, [_vm.imgDesktop ? _c('img', {
    staticClass: "group-title__img group-title__img_desktop",
    attrs: {
      "src": _vm.imgDesktop
    }
  }) : _vm._e(), _vm._v(" "), _vm.imgMobile ? _c('img', {
    staticClass: "group-title__img group-title__img_mobile",
    attrs: {
      "src": _vm.imgMobile
    }
  }) : _vm._e()]), _vm._v(" "), _vm.iconRight ? _c('div', {
    staticClass: "group-title__icon",
    style: {
      backgroundImage: ("url(" + (_vm.iconRight) + ")")
    }
  }) : _vm._e()], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }